import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { Netcalc } from "./netcalc/Netcalc"
import "./scss/netcalc.scss";

const root = document.getElementById('netcalc-app');

if (!root)
{
    throw new Error("Не найден корневой контейнер #netcalc-app для размещения REACT-компонента");
}

const netcalcApp = createRoot(root);

netcalcApp.render(
    <StrictMode>
        <Netcalc />
    </StrictMode>
);